import React from 'react';
import isFunction from 'lodash/isFunction';
import ModalModule from '../modal';

const { Modal, ModalButtonActionType } = ModalModule;

const DeleteTagModal = ({ data: { name, onDeleteCallback }, modalId }) => {
	const onDeleteButtonClick = closeModal => {
		if (isFunction(onDeleteCallback)) {
			onDeleteCallback();
		}

		closeModal();
	};

	const primaryButton = {
		type: ModalButtonActionType.Ok,
		text: 'Yes',
		onClick: onDeleteButtonClick,
		dataqa: 'delete-tag-yes-button',
	};

	const secondaryButton = {
		type: ModalButtonActionType.Cancel,
		text: 'No',
		dataqa: 'delete-tag-no-button',
	};

	return (
		<Modal
			modalId={modalId}
			className="common-tags delete-tag-modal warning-modal"
			header="Delete Tag"
			primaryButton={primaryButton}
			secondaryButton={secondaryButton}
			size="small"
		>
			<div className="body">
				<p>{`Delete Tag "${name}"?`}</p>
			</div>
		</Modal>
	);
};

export default DeleteTagModal;
